import nautilusApi from '../../nautilusApi'

export async function fetchIndicator({ type, value }) {
  /**
   * NOTE:
   *
   * This is temporary, we will replace this with always
   * calling the /:type/:value route instead
   */
  const params = ['explainer=true']
  const path = `/api/v4/indicator/${type}${value === undefined ? '' : `/${encodeURIComponent(value)}`}?${params.join('&')}`
  return nautilusApi.fetch(path)
}
